export default "__VITE_ASSET__kahfy0S8__"